import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { HelmetProvider } from "react-helmet-async";
import "@mantine/core/styles.css";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <MantineProvider>
        <App />
      </MantineProvider>
    </HelmetProvider>
  </React.StrictMode>
);
